import { BaseModel } from "./BaseModel";

export class Location extends BaseModel {
  schema = "/location";
  constructor(params) {
    return super(params, "/location");
  }
}
